export const LanguageConstants = {
    FETCHING_LANGUAGE:'FETCHING_LANGUAGE',
    FETCHING_LANGUAGE_SUCCESS:'FETCHING_LANGUAGE_SUCCESS',
    FETCHING_LANGUAGE_FAILURED:'FETCHING_LANGUAGE_FAILURED'
}